import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { toast } from 'react-toastify';
import { AdminActionButton } from './AdminRowActions';
import {
  copyTextToClipboard,
  formatShippingAddressForCopy,
} from '../../helper/order_address_helper';

async function handleCopy(text, successMessage) {
  try {
    await copyTextToClipboard(text);
    toast.success(successMessage || 'Copied');
  } catch {
    toast.error('Could not copy to clipboard');
  }
}

export default function OrderDetailShippingCard({ shippingAddress = {} }) {
  const addressCopyText = formatShippingAddressForCopy(shippingAddress);
  const hasAddressBlock = Boolean(addressCopyText.trim());

  return (
    <>
      <div className="d-flex align-items-center justify-content-between gap-2 mb-3">
        <h6 className="mb-0 fw-bold">
          <i className="ri-map-pin-line me-1" />
          Shipping Address
        </h6>
        {hasAddressBlock ? (
          <AdminActionButton
            action="copy"
            label="Copy shipping address"
            aria-label="Copy shipping address"
            onClick={() => handleCopy(addressCopyText, 'Address copied')}
          />
        ) : null}
      </div>
      <Card className="mb-3 border">
        <CardBody className="p-3">
          <p className="mb-1">
            <strong>
              {shippingAddress.firstName} {shippingAddress.lastName}
            </strong>
          </p>
          {shippingAddress.street ? (
            <p className="mb-1 text-muted small">{shippingAddress.street}</p>
          ) : null}
          {shippingAddress.city || shippingAddress.state || shippingAddress.zipcode ? (
            <p className="mb-1 text-muted small">
              {shippingAddress.city}, {shippingAddress.state} - {shippingAddress.zipcode}
            </p>
          ) : null}
          {shippingAddress.country ? (
            <p className="mb-1 text-muted small">{shippingAddress.country}</p>
          ) : null}
          {shippingAddress.email ? (
            <div className="d-flex align-items-center flex-wrap gap-2 mb-1">
              <span className="text-muted small">{shippingAddress.email}</span>
              <AdminActionButton
                action="copy"
                label="Copy email address"
                aria-label="Copy email address"
                onClick={() => handleCopy(shippingAddress.email, 'Email copied')}
              />
            </div>
          ) : null}
          {shippingAddress.phone ? (
            <div className="d-flex align-items-center flex-wrap gap-2 mb-0">
              <span className="text-muted small">
                <i className="ri-phone-line me-1" />
                {shippingAddress.phone}
              </span>
              <AdminActionButton
                action="copy"
                label="Copy phone number"
                aria-label="Copy phone number"
                onClick={() => handleCopy(shippingAddress.phone, 'Phone number copied')}
              />
            </div>
          ) : null}
        </CardBody>
      </Card>
    </>
  );
}
